import { render, staticRenderFns } from "./MediaSlot.vue?vue&type=template&id=8d564078&scoped=true&"
import script from "./MediaSlot.vue?vue&type=script&lang=js&"
export * from "./MediaSlot.vue?vue&type=script&lang=js&"
import style0 from "./MediaSlot.vue?vue&type=style&index=0&id=8d564078&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d564078",
  null
  
)

export default component.exports